module.exports = __webpack_public_path__ + "media/images/icons/512x512-4b1075ba766e7ee36e298b1a8b90b8e2.png";